import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
////THIS LINES WORKED BEFORE
import { useContext } from "react";
import { CartContext } from "../components/CartContext";

// // // DATA
import celeMaiVindute from "../data/celeMaiVindute";
import buchete from "../data/buchete";
import bucheteTrandafiri from "../data/bucheteTrandafiri";
import compozitiiCutie from "../data/compozitiiCutie";
//PREMIUM
import buchetePremium from "../data/buchetePremium";
//BucheteSezon
import paisprezeceFebruarie from "../data/paisprefebruarie";
import optMartie from "../data/optmartie";
import bucheteMireasa from "../data/bucheteMireasa";
import compozitiiDeIarna from "../data/compozitiiDeIarna";
import bucheteIarnaPrimavara from "../data/bucheteIarnaPrimavara";
import bucheteDeVara from "../data/bucheteDeVara";
import bucheteDeToamna from "../data/bucheteDeToamna";
//IMAGES
import ferrero from "../img/ferrero.webp";
import merci from "../img/merci.webp";
import martini from "../img//martini.webp";

// popup
import DeliveryPopup from "./DeliveryPopup";
import CartPopup from "../components/CartPopup";
import ErrorModal from "../components/ErrorModal";
/* global fbq */ // <-- ADD THIS LINE
const flowers = [
  ...celeMaiVindute,
  ...buchete,
  ...bucheteTrandafiri,
  ...compozitiiCutie,
  ...buchetePremium,
  ...paisprezeceFebruarie,
  ...optMartie,
  ...bucheteMireasa,
  ...compozitiiDeIarna,
  ...bucheteIarnaPrimavara,
  ...bucheteDeVara,
  ...bucheteDeToamna,
];

const FlowerDetails = () => {
  const { id } = useParams();
  const flower = flowers.find((f) => String(f.id) === id);

  const [selectedExtras, setSelectedExtras] = useState({});
  const [showCartPopup, setShowCartPopup] = useState(false);
  const greetingText = document.querySelector(".message-form")?.value;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showDeliveryPopup, setShowDeliveryPopup] = useState(false);

  const [quantity, setQuantity] = useState(1);

  const { cartItems, setCartItems } = useContext(CartContext);
  // const { addToCart } = useContext(CartContext);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleAddToCart = () => {
    const easternEuropeTime = getCurrentEasternEuropeTime();
    const currentHour = easternEuropeTime.getHours();
    const eetFormattedToday = easternEuropeTime.toISOString().split("T")[0];
    const isToday = selectedDate === eetFormattedToday;

    if (!selectedDate || !selectedTime) {
      setShowDeliveryPopup(true);
      return;
    }

    if (isToday) {
      // For morning delivery (9:00-14:00)
      if (selectedTime === "09:00-14:00" && currentHour >= 11) {
        setShowErrorModal(true);
        return;
      }

      // For afternoon delivery (14:00-19:00)
      if (selectedTime === "14:00-19:00" && currentHour >= 16) {
        setShowErrorModal(true);
        return;
      }
    }

    const newItem = {
      // id: flower.id,
      id: `${flower.id}-${Date.now()}`,
      name: flower.name,
      price: parseFloat(flower.price) || 0,
      image: flower.images[0],
      quantity: quantity,
      deliveryDate: selectedDate,
      deliveryTime: selectedTime,
      greetingText: greetingText || null,
      extras: Object.entries(selectedExtras)
        .filter(([_, selected]) => selected)
        .map(([id]) => {
          const extra = extraOptions.find((e) => e.id === id);
          return {
            id: `${flower.id}-${extra.id}-${Date.now()}`, // Create unique ID
            originalId: extra.id,
            name: extra.name,
            image: extra.image,
            price: parseFloat(extra.price) || 0,
          };
        }),
    };
    // --- START ADDITION FOR ADD TO CART ---
    // Calculate the total value of the item being added, including selected extras
    let itemValue = parseFloat(flower.price) * quantity;
    newItem.extras.forEach((extra) => {
      itemValue += parseFloat(extra.price);
    });

    if (window.fbq && flower) {
      // Ensure Pixel is loaded and flower data is available
      fbq("track", "AddToCart", {
        content_name: flower.name, // Name of the main product
        content_ids: [String(flower.id)], // ID of the main product
        content_type: "product",
        value: itemValue, // Total value of the item + extras being added
        currency: "MDL",
      });
      console.log(
        "Meta Pixel: AddToCart event fired for:",
        flower.name,
        "Value:",
        itemValue
      ); // For testing
    }
    // --- END ADDITION FOR ADD TO CART ---
    setCartItems([...cartItems, newItem]);
    setShowCartPopup(true);
  };

  // Update the removeFromCart function:
  const removeFromCart = (itemId, extraId = null) => {
    setCartItems((prevItems) => {
      if (extraId) {
        // Remove specific extra option using the unique ID
        return prevItems.map((item) => {
          if (item.id === itemId) {
            return {
              ...item,
              extras: item.extras.filter((extra) => extra.id !== extraId),
            };
          }
          return item;
        });
      } else {
        // Remove entire item
        return prevItems.filter((item) => item.id !== itemId);
      }
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (window.fbq && flower?.id) {
      window.fbq("track", "ViewContent", {
        content_name: flower.name,
        content_ids: [String(flower.id)],
        content_type: "product",
        value: Number(flower.price),
        currency: "MDL",
      });

      console.log("Meta Pixel: ViewContent fired:", flower.name);
    }
  }, [flower?.id]);

  // --- END ADDITION FOR VIEWCONTENT ---

  const toggleExtra = (extra) => {
    setSelectedExtras((prev) => ({
      ...prev,
      [extra]: !prev[extra],
    }));
  };

  const extraOptions = [
    {
      id: "ferrero",
      name: "Ferrero Rocher, 200 g",
      image: ferrero,
      price: 240,
    },
    {
      id: "merci",
      name: "Merci ciocolata asortată, 250 g",
      image: merci,
      price: 260,
    },
    {
      id: "martini",
      name: "Vin spumant Martini Asti, 0,75 L",
      image: martini,
      price: 350,
    },
  ];
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);

  // const getCurrentEasternEuropeTime = () => {
  //   const now = new Date();

  //   // Convert to UTC time first
  //   const utcYear = now.getUTCFullYear();
  //   const utcMonth = now.getUTCMonth();
  //   const utcDate = now.getUTCDate();
  //   const utcHours = now.getUTCHours();
  //   const utcMinutes = now.getUTCMinutes();
  //   const utcSeconds = now.getUTCSeconds();

  //   // Determine if DST is in effect for Eastern Europe
  //   // Eastern European Summer Time (EEST) typically starts on the last Sunday in March
  //   // and ends on the last Sunday in October
  //   const isDST = (() => {
  //     // Create a Date object for the current UTC time
  //     const testDate = new Date(
  //       Date.UTC(utcYear, utcMonth, utcDate, utcHours, utcMinutes, utcSeconds)
  //     );

  //     // Get the last Sunday of March
  //     const marchLastSunday = new Date(utcYear, 2, 31);
  //     marchLastSunday.setDate(
  //       marchLastSunday.getDate() - marchLastSunday.getDay()
  //     );

  //     // Get the last Sunday of October
  //     const octoberLastSunday = new Date(utcYear, 9, 31);
  //     octoberLastSunday.setDate(
  //       octoberLastSunday.getDate() - octoberLastSunday.getDay()
  //     );

  //     // DST is active if current date is between these Sundays
  //     return testDate >= marchLastSunday && testDate < octoberLastSunday;
  //   })();

  //   // Apply EET offset: UTC+2 in winter, UTC+3 in summer (during DST)
  //   const eetOffset = isDST ? 3 : 2;

  //   // Create a new date with the Eastern European Time offset from UTC
  //   return new Date(
  //     Date.UTC(
  //       utcYear,
  //       utcMonth,
  //       utcDate,
  //       utcHours + eetOffset,
  //       utcMinutes,
  //       utcSeconds
  //     )
  //   );
  // };
  // Then find the updateAvailableTimeSlots function and wrap it with useCallback

  const getCurrentEasternEuropeTime = useCallback(() => {
    const now = new Date();

    // Convert to UTC time first
    const utcYear = now.getUTCFullYear();
    const utcMonth = now.getUTCMonth();
    const utcDate = now.getUTCDate();
    const utcHours = now.getUTCHours();
    const utcMinutes = now.getUTCMinutes();
    const utcSeconds = now.getUTCSeconds();

    // Determine if DST is in effect for Eastern Europe
    const isDST = (() => {
      // Create a Date object for the current UTC time
      const testDate = new Date(
        Date.UTC(utcYear, utcMonth, utcDate, utcHours, utcMinutes, utcSeconds)
      );

      // Get the last Sunday of March
      const marchLastSunday = new Date(utcYear, 2, 31);
      marchLastSunday.setDate(
        marchLastSunday.getDate() - marchLastSunday.getDay()
      );

      // Get the last Sunday of October
      const octoberLastSunday = new Date(utcYear, 9, 31);
      octoberLastSunday.setDate(
        octoberLastSunday.getDate() - octoberLastSunday.getDay()
      );

      // DST is active if current date is between these Sundays
      return testDate >= marchLastSunday && testDate < octoberLastSunday;
    })();

    // Apply EET offset: UTC+2 in winter, UTC+3 in summer (during DST)
    const eetOffset = isDST ? 3 : 2;

    // Create a new date with the Eastern European Time offset from UTC
    return new Date(
      Date.UTC(
        utcYear,
        utcMonth,
        utcDate,
        utcHours + eetOffset,
        utcMinutes,
        utcSeconds
      )
    );
  }, []);
  const updateAvailableTimeSlots = useCallback(() => {
    const easternEuropeTime = getCurrentEasternEuropeTime();
    const currentHour = easternEuropeTime.getHours();

    // Format today's date consistently as YYYY-MM-DD
    const year = easternEuropeTime.getFullYear();
    const month = String(easternEuropeTime.getMonth() + 1).padStart(2, "0");
    const day = String(easternEuropeTime.getDate()).padStart(2, "0");
    const eetFormattedToday = `${year}-${month}-${day}`;

    // Check if selected date is today in EET
    const isToday = selectedDate === eetFormattedToday;

    let slots = [];
    const morningSlot = { value: "09:00-14:00", label: "9:00 - 14:00" };
    const afternoonSlot = { value: "14:00-19:00", label: "14:00 - 19:00" };
    // if (isToday) {
    //   if (currentHour < 15) {
    //     slots.push(afternoonSlot);
    //   }
    // } else {
    //   slots = [afternoonSlot];
    // }

    // setAvailableTimeSlots(slots);

    // if (selectedTime && !slots.find((slot) => slot.value === selectedTime)) {
    //   setSelectedTime("");
    // }
    if (isToday) {
      // For morning slot (9:00-14:00)
      // Only show if it's before 11:00 EET

      if (currentHour < 11) {
        slots.push(morningSlot);
      }
      // For afternoon slot (14:00-19:00)
      // Only show if it's before 16:00 EET
      if (currentHour < 15) {
        slots.push(afternoonSlot);
      }
    } else {
      // For future dates, both slots are available
      slots = [morningSlot, afternoonSlot];
    }

    setAvailableTimeSlots(slots);

    // Clear selected time if it's no longer available
    if (selectedTime && !slots.find((slot) => slot.value === selectedTime)) {
      setSelectedTime("");
    }
  }, [selectedDate, selectedTime, getCurrentEasternEuropeTime]);

  // Then keep your useEffect the same but with the dependency
  useEffect(() => {
    updateAvailableTimeSlots();
  }, [updateAvailableTimeSlots]);
  // Function to get EET-formatted date string
  // const getEETFormattedDate = (date) => {
  //   const eetDate = new Date(date);
  //   return eetDate.toISOString().split("T")[0];
  // };
  // const updateAvailableTimeSlots = () => {
  //   const easternEuropeTime = getCurrentEasternEuropeTime();
  //   const currentHour = easternEuropeTime.getHours();

  //   // Format today's date consistently as YYYY-MM-DD
  //   const year = easternEuropeTime.getFullYear();
  //   const month = String(easternEuropeTime.getMonth() + 1).padStart(2, "0");
  //   const day = String(easternEuropeTime.getDate()).padStart(2, "0");
  //   const eetFormattedToday = `${year}-${month}-${day}`;

  //   // Check if selected date is today in EET
  //   const isToday = selectedDate === eetFormattedToday;

  //   let slots = [];
  //   const morningSlot = { value: "09:00-14:00", label: "9:00 - 14:00" };
  //   const afternoonSlot = { value: "14:00-19:00", label: "14:00 - 19:00" };

  //   if (isToday) {
  //     // For morning slot (9:00-14:00)
  //     // Only show if it's before 11:00 EET
  //     if (currentHour < 11) {
  //       slots.push(morningSlot);
  //     }

  //     // For afternoon slot (14:00-19:00)
  //     // Only show if it's before 16:00 EET
  //     if (currentHour < 16) {
  //       slots.push(afternoonSlot);
  //     }
  //   } else {
  //     // For future dates, both slots are available
  //     slots = [morningSlot, afternoonSlot];
  //   }

  //   setAvailableTimeSlots(slots);

  //   // Clear selected time if it's no longer available
  //   if (selectedTime && !slots.find((slot) => slot.value === selectedTime)) {
  //     setSelectedTime("");
  //   }
  // };
  // useEffect(() => {
  //   updateAvailableTimeSlots();
  // }, [updateAvailableTimeSlots]);

  const getMinDate = () => {
    // Get current time in Eastern Europe
    const easternEuropeTime = getCurrentEasternEuropeTime();
    const currentHour = easternEuropeTime.getHours();

    // If it's after 16:00 EET, only allow orders for next day
    if (currentHour >= 23) {
      const tomorrow = new Date(easternEuropeTime);
      tomorrow.setDate(tomorrow.getDate() + 1);
      // Format to YYYY-MM-DD with proper padding of months and days
      const year = tomorrow.getFullYear();
      const month = String(tomorrow.getMonth() + 1).padStart(2, "0");
      const day = String(tomorrow.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    // Format today with proper padding
    const year = easternEuropeTime.getFullYear();
    const month = String(easternEuropeTime.getMonth() + 1).padStart(2, "0");
    const day = String(easternEuropeTime.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    updateAvailableTimeSlots();
  }, [updateAvailableTimeSlots]);

  const calculateTotal = () => {
    if (!cartItems || cartItems.length === 0) return 0;

    return cartItems
      .reduce((total, item) => {
        const itemPrice = parseFloat(item.price) || 0;
        const quantity = parseInt(item.quantity) || 0;
        const extrasTotal = item.extras
          ? item.extras.reduce(
              (sum, extra) => sum + (parseFloat(extra.price) || 0),
              0
            )
          : 0;

        return total + itemPrice * quantity + extrasTotal;
      }, 0)
      .toFixed(2);
  };
  const shouldShowGreeting = () => {
    const greetingText = document.querySelector(".message-form")?.value;
    return greetingText && greetingText.trim() !== "";
  };

  return (
    <div className=" section flower-details-container">
      <ErrorModal
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
      />
      <div className="flower-details">
        <div className="flower-image">
          <img src={flower.images[0]} alt={flower.name} />
          <p className="flower-description">
            Dacă intilnesti dificultăți in efectuarea comenzii ne poți contacta
            aici.
          </p>
          <ul className="social-media-list">
            <li>
              <a
                href="https://wa.me/37378774774"
                className="btn social__media--link"
                title="WhatsApp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-whatsapp social__media--icon"></i>
              </a>
            </li>
            <li>
              <a
                href="https://t.me/+37378774774"
                className="btn social__media--link"
                title="Telegram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-telegram social__media--icon"></i>
              </a>
            </li>
            <li className="contact">
              <a
                href="tel:+37378774774"
                className="btn phone-contact"
                title="Telefon"
              >
                <i className="fa-solid fa-phone"></i>
                +373 78 774 774
              </a>
            </li>
          </ul>
        </div>
        <div className="flower-info">
          <h5 className="flower__det--name">{flower.name}</h5>
          <p className="flower__det--price">{flower.price}</p>
          <p className="flower-description">{flower.description}</p>

          <div className="extras">
            <h3>Adaugă extraopțiuni</h3>
            <div className="extra-items-grid">
              {extraOptions.map((extra, index) => (
                <div
                  key={extra.id} // Use a unique identifier as the key
                  className={`extra-item ${
                    selectedExtras[extra.id] ? "selected" : ""
                  }`}
                  onClick={() => toggleExtra(extra.id)} // Pass the unique id to toggle
                >
                  <img src={extra.image} alt={`Extra option ${index + 1}`} />
                  <p>{extra.price} lei</p>
                  {selectedExtras[extra.id] && (
                    <div className="checkmark">✔</div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <form className="flower-details-form">
            {/* Greeting Card Text */}
            <label className="form-section form-text">
              Text pentru felicitare:
              <textarea
                className="message-form"
                placeholder="Scrie mesajul tău aici..."
              />
            </label>

            <div className="form-section form-date-hour">
              <label>
                Alege data livrării:
                <input
                  type="date"
                  min={getMinDate()}
                  value={selectedDate}
                  onChange={(e) => {
                    // Validate that the selected date is not before min date
                    const minDate = getMinDate();
                    const selectedValue = e.target.value;

                    if (selectedValue < minDate) {
                      // If selected date is before min date, set to min date
                      setSelectedDate(minDate);
                    } else {
                      setSelectedDate(selectedValue);
                    }
                  }}
                />
              </label>
              <label>
                Alege ora livrării:
                <select
                  className="time-select "
                  value={selectedTime}
                  onChange={(e) => setSelectedTime(e.target.value)}
                >
                  <option value="">Selectează intervalul orar</option>
                  {availableTimeSlots.map((slot) => (
                    <option key={slot.value} value={slot.value}>
                      {slot.label}
                    </option>
                  ))}
                </select>
              </label>
            </div>

            {/* Quantity Selector */}

            <div className="form-section quantity-addtoCart ">
              <div>
                <div className="quantity-selector">
                  Cantitate:
                  <button
                    className="btn btn-quantity"
                    type="button"
                    onClick={() => setQuantity((q) => Math.max(q - 1, 1))}
                  >
                    &lt;
                  </button>
                  <span>{quantity}</span>
                  <button
                    className="btn btn-quantity"
                    type="button"
                    onClick={() => setQuantity((q) => q + 1)}
                  >
                    &gt;
                  </button>
                </div>
              </div>

              <button
                type="button"
                className="btn addToCart"
                onClick={handleAddToCart} // Updated click handler
              >
                Adaugă în coș
              </button>

              <DeliveryPopup
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
              />
            </div>
          </form>
        </div>
      </div>
      <div className="tab-container">
        <p className="tab-text">
          Prețul produsului pe care l-ați ales din florăria Gardenia include o
          felicitare cadou, pe care vom scrie caligrafic textul ales de
          dumneavoastră. În cazul în care elemente ale produsului ales nu sunt
          în stoc la momentul livrării, le vom înlocui cu unele similare, astfel
          încat aspectul general al acestuia să nu se modifice. Extraopțiunile
          sunt cu titlu de prezentare și nu sunt incluse în prețul produsului.
          Acestea pot fi comandate alături de produsele dorite, din categoria
          "Extraopțiuni".
        </p>
      </div>
      <div className="payment-delivery-container">
        <div className="flowers-method-sub">
          <h3>Metode de plată</h3>
          <p>Visa / Master Card, Paynet pe website</p>
          <p>Achitare cu card/cash in magazin</p>
          <p>Achitarea cash la livrare</p>
        </div>
        <div className="flowers-method-sub">
          <h3>Condiții de livrare</h3>
          <p>
            Livrăm zilnic între <strong>09:00 - 19:00</strong>.
          </p>
          <p>
            Comenzile pentru livrare în raza orașului Chișinău trebuie plasate
            până la ora
            <strong> 16:00</strong>.
          </p>
          <p>
            Livrarea la oră fixă și livrare expres este posibilă contra unei
            taxe suplimentare și necesită aprobarea managerului de vânzări.
          </p>

          <div className="contact-condition-delivery">
            <span>
              Pentru urgențe sau comenzi speciale, contactați-ne pe{" "}
              <strong>WhatsApp, Telegram</strong> sau la{" "}
              <strong>+37378774774.</strong>
            </span>
          </div>
        </div>
        <div className="flowers-method-sub">
          <h3>📍 Zonele de livrare și tarife</h3>
          <p>
            În raza orașului Chișinău (sectoarele Centru, Buiucani, Botanica,
            Ciocana, Riscani)
          </p>
          <p>
            • Pentru comenzi de până la 1200 lei - <strong>100 lei</strong>
          </p>
          • Pentru comenzi de peste 1200 lei - <strong>Gratuit</strong>
          <p>
            Livrare la oră fixă <strong>+200 lei</strong> (se confirmă
            telefonic).
          </p>
          <p>
            <strong>În Republica Moldova: </strong>costul livrării este calculat
            în momentul plasării comenzii. Comanda trebuie plasată cu 24 de ore
            în avans.
          </p>
        </div>
      </div>
      {/* Update the CartPopup implementation */}
      <CartPopup
        isOpen={showCartPopup}
        onClose={() => setShowCartPopup(false)}
        cartItems={cartItems}
        selectedDate={selectedDate}
        selectedTime={selectedTime}
        greetingText={
          shouldShowGreeting()
            ? document.querySelector(".message-form")?.value
            : null
        }
        removeFromCart={removeFromCart}
        total={calculateTotal()}
      />
      <DeliveryPopup
        isOpen={showDeliveryPopup}
        onClose={() => setShowDeliveryPopup(false)}
      />
    </div>
  );
};
export default FlowerDetails;
